import { gql } from '@apollo/client'
import { useActionMutation, type UseMutationProps } from '@ztechapps/common.hook'
import type { Task, StateTransitionArgs } from '@ztechapps/common.contract'
import { TaskStatusEnum } from '@ztechapps/common.contract'
import { taskDocumentFragment } from './graphql'

export const changeTaskStatusQuery = gql`
  mutation changeTaskStatus($input: StateTransitionArgs!) {
    changeTaskStatus(input: $input) {
      ...taskDocumentFragment
    }
  }
  ${taskDocumentFragment}
`

export const useTaskStateTransition = ({ query, ...props } = {} as Partial<UseMutationProps>) => {
  query = query ?? changeTaskStatusQuery

  const [_changeStatus, result] = useActionMutation<Task, StateTransitionArgs<Task>>({
    query,
    ...props,
  })

  const changeStatus = (targetState: TaskStatusEnum, taskId: string) => {
    const filter = { _id: taskId }
    return _changeStatus({ targetState, filter }, filter, taskId)
  }

  const moveToInProgress = (_id: string) => {
    return changeStatus(TaskStatusEnum.InProgress, _id)
  }

  const moveToComplete = (_id: string) => {
    return changeStatus(TaskStatusEnum.Complete, _id)
  }

  const moveToCancel = (_id: string) => {
    return changeStatus(TaskStatusEnum.Cancelled, _id)
  }

  const moveToDraft = (_id: string) => {
    return changeStatus(TaskStatusEnum.Draft, _id)
  }

  return [
    {
      changeStatus,
      moveToInProgress,
      moveToComplete,
      moveToCancel,
      moveToDraft,
    },
    result,
  ] as const
}
